import { BaseSyntheticEvent, useContext } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";
import TooltipConfig from "../../../../../components/Tooltip";

const ViewButton = ({ id }: { id: string }) => {
  const { shortToken } = useParams();
  const { hasShortToken } = useContext(AuthContext);

  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }

  function onClick(id: string) {
    let routeNavigate = "";
    if (hasShortToken) {
      routeNavigate = `/dashboard/view/${id}/${shortToken}`;
    } else {
      routeNavigate = `/dashboard/view/${id}`;
    }
    window.open(routeNavigate);
  }

  return (
    <TooltipConfig
      content={["Visualizar"]}
      children={
        <IoEyeOutline
          onMouseOver={MouseOver}
          size={26}
          onClick={() => onClick(id)}
        />
      }
      placement={"bottom"}
      style={true}
    />
  );
};

export default ViewButton;
